import { render, staticRenderFns } from "./AiAssistantSession.vue?vue&type=template&id=3bbc576e&scoped=true&"
import script from "./AiAssistantSession.vue?vue&type=script&lang=js&"
export * from "./AiAssistantSession.vue?vue&type=script&lang=js&"
import style0 from "./AiAssistantSession.vue?vue&type=style&index=0&id=3bbc576e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbc576e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/vue-sellerwell-web-erp-service-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bbc576e')) {
      api.createRecord('3bbc576e', component.options)
    } else {
      api.reload('3bbc576e', component.options)
    }
    module.hot.accept("./AiAssistantSession.vue?vue&type=template&id=3bbc576e&scoped=true&", function () {
      api.rerender('3bbc576e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GlobalHeader/modal/AiAssistantDrawer/AiAssistantSession.vue"
export default component.exports